import { render, staticRenderFns } from "./IndexBrandSearchItems.vue?vue&type=template&id=b4bbfc4a&scoped=true&"
import script from "./IndexBrandSearchItems.vue?vue&type=script&lang=js&"
export * from "./IndexBrandSearchItems.vue?vue&type=script&lang=js&"
import style0 from "./IndexBrandSearchItems.vue?vue&type=style&index=0&id=b4bbfc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bbfc4a",
  null
  
)

export default component.exports